<template>
    <div id="chat-messages">
        <MessageList
            v-if="!messageSyncRunning"
            :always-scroll-to-bottom="true"
            :colors="colors"
            :is-colored="true"
            :ischatwindow="true"
            :messages="messages"
            :participants="getParticipants()"
            :scroll-top="false"
            :is-whatsapp="!!contact.lastConversation.whatsappNumber"
            :channel-id="contact.lastConversation.channel"
        />
    </div>
</template>

<script>
import MessageList from "../MessageList.vue";
import { mapState } from "vuex";

export default {
    name: "ChatMessageList",
    components: { MessageList },
    props: {
        contact: {
            type: Object,
            default: () => ({}),
        },
        messageSyncRunning: {
            type: Boolean,
            default: false,
        },
        messages: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        colors: {
            header: {
                bg: "#4e8cff",
                text: "#ffffff",
            },
            launcher: {
                bg: "#4e8cff",
            },
            messageList: {
                bg: "#ffffff",
            },
            sentMessage: {
                bg: "#F2EDFF",
                text: "#222222",
            },
            receivedMessage: {
                bg: "#F1F4F7",
                text: "#222222",
            },
            userInput: {
                bg: "#f4f7f9",
                text: "#565867",
            },
        },
    }),
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            liveVisitors: (state) => state.visitor.liveVisitors,
            watchingContactIds: (state) => state.chat.watchingContactIds,
        }),
    },
    methods: {
        getParticipants() {
            const supportUsers = this.messages
                .filter((x) => x.messageType === "user" || x.messageType === "private")
                .map((x) => ({
                    id: x.userId,
                    name: x.username,
                }));

            return this.$_.uniqBy(supportUsers, (q) => q.name);
        },
    },
};
</script>
<style lang="scss" scoped>
#chat-messages {
    position: relative;
    height: 100%;
    overflow: hidden;

    .sc-message-list {
        &::-webkit-scrollbar {
            display: none;
            width: 0;
        }
    }
}
</style>
